import { z } from 'zod';

/**
 * CF-D-1 · `GET /api/progress/activity?weeks=N` response shape.
 *
 * Derived from `progress.events[]` (Q-2 events stream filtered к
 * `ticket-status-change → done`) with `progress.tickets[].completedAt` fallback
 * for buckets older than 90d (events pruned per ADR-009).
 *
 * Consumer: `app/src/screens/Progress.tsx` activity heatmap (was graceful-degrade
 * fallback к client-side `deriveActivityWeeksLocal`).
 *
 * See `COORDINATION/CF-D-1_progress_activity_endpoint_spec.md` для derivation logic.
 */

export const ActivityWeekSchema = z.object({
  /** ISO 8601 date · Monday of ISO week (`YYYY-MM-DD`). */
  weekStart: z.string(),
  /** ISO 8601 week designator (`YYYY-Www`). */
  weekKey: z.string(),
  /** Count of tickets transitioned к `done` в этой week. */
  ticketsCompleted: z.number().int().nonnegative(),
  /** Normalized 0..100 · peak week = 100 within returned set. */
  pctOfPeak: z.number().int().min(0).max(100),
  /** True для week containing now() (server clock). */
  current: z.boolean(),
});

export const ActivityWeeksResponseSchema = z.object({
  weeks: z.array(ActivityWeekSchema),
});

export type ActivityWeek = z.infer<typeof ActivityWeekSchema>;
export type ActivityWeeksResponse = z.infer<typeof ActivityWeeksResponseSchema>;
